import Crud from "./baseCrud";
import axios from "axios";

const API_LIST_URL = `/api/task/list`;
const API_ADD_URL = `/api/task/add`;
const API_UPDATE_URL = `/api/task/update`;
const API_DELETE_URL = `/api/task/delete`;

const NAME_ITEMS = 'tasks';
const NAME_ITEM = 'task';

export default new Crud({
    API_LIST_URL,
    API_ADD_URL,
    API_UPDATE_URL,
    API_DELETE_URL,

    NAME_ITEMS,
    NAME_ITEM
}, {
    state: {
        predict: null,
        optimize: null,
        wells: null,
    },
    actions: {
        async loadItem({commit}, problemId) {
            if (!API_LIST_URL) {
                return;
            }

            let response = await axios.post(API_LIST_URL, {filter: {'problemId': problemId}});
            let item = response.data[NAME_ITEMS][0];
            return commit('setEditItem', item);
        },
        async loadItemById({commit}, taskId) {
            if (!API_LIST_URL) {
                return;
            }

            let response = await axios.post(API_LIST_URL, {filter: {'id': taskId}, show_full: true});
            let item = response.data[NAME_ITEMS][0];
            await commit('setEditItem', item);
            return item;
        },
        async loadPredictItem({commit}, problemId) {
            if (!API_LIST_URL) {
                return;
            }

            let response = await axios.post(API_LIST_URL, {
                filter: {'problemId': problemId, type: 'predict'},
                show_full: true}
            );
            let item = response.data[NAME_ITEMS][0];
            return commit('setPredictItem', item);
        },
        async setEditItem({commit, state}, problemId) {
            let item = state.list.find(item => item.problemId === problemId);
            if (item) {
                commit('setEditItem', item);
            }
        },
        async setOptimizeItem({commit, state}, problemId) {
            let item = state.list.find(item => item.problemId === problemId && item.type === 'optimize');
            if (item) {
                commit('setOptimizeItem', item);
            }
        },
        async setWellsItem({commit, state}, problemId) {
            let item = state.list.find(item => item.problemId === problemId && item.type === 'wells');
            if (item) {
                commit('setWellsItem', item);
            }
        },
        async setPredictItem({commit, state}, problemId) {
            let item = state.list.find(item => item.problemId === problemId && item.type === 'predict');
            if (item) {
                commit('setPredictItem', item);
            }
        },
    },
    mutations: {
        setOptimizeItem(state, item) {
            state.optimize = item;
        },
        setWellsItem(state, item) {
            state.wells = item;
        },
        setPredictItem(state, item) {
            state.predict = item;
        },
    }
});